import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';

import { checkRelogin } from '@/api';
import { ROUTES } from '@/constants';
import { getSessionToken } from '@/helpers';
import { useConsentSync } from '@/hooks';
import { PermissionsProvider } from '@/permissions';
import PrivateLayout from './PrivateLayout';

const PrivateRoute: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [check, { loading }] = useLazyQuery(checkRelogin);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useConsentSync(getSessionToken());

  useEffect(() => {
    const checkSession = async () => {
      const { data } = await check();
      // this means the user is logged out on the snappea
      if (data?.checkReloginQuery === null) {
        navigate(ROUTES.logout, {
          state: { referrer: pathname },
        });
        return;
      }

      if (data?.checkReloginQuery?.needsRelogin) {
        const url = new URL(`${import.meta.env.VITE_MY_FOODA_APP_URL}/relogin`);
        url.searchParams.append('return_to', encodeURIComponent(window.location.href));

        window.location.href = url.href;
      }
    };

    if (!loading) {
      checkSession();
    }
  }, [pathname]);

  return (
    <PermissionsProvider>
      <PrivateLayout>{children}</PrivateLayout>
    </PermissionsProvider>
  );
};

export default PrivateRoute;
